export default "__VITE_ASSET__DGe1AFns__"